/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Ui_Charts_Rest_Of_TotalInputs */

const en_us2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.total}`)
};

const pt_br2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const es_419_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const pt_pt2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const fr_fr2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sur ${i?.total}`)
};

const de_de2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`von ${i?.total}`)
};

const it_it2_ui_charts_rest_of_total = /** @type {(inputs: Ui_Charts_Rest_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "of {total}" |
*
* @param {Ui_Charts_Rest_Of_TotalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_rest_of_total = /** @type {((inputs: Ui_Charts_Rest_Of_TotalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Rest_Of_TotalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_rest_of_total(inputs)
	if (locale === "es-419") return es_419_ui_charts_rest_of_total(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_rest_of_total(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_rest_of_total(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_rest_of_total(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_rest_of_total(inputs)
	return en_us2_ui_charts_rest_of_total(inputs)
});
export { ui_charts_rest_of_total as "ui-charts.rest_of_total" }